import axiosInstance from "./auth";

export const getReferralStats = async () => {
  try {
    const response = await axiosInstance.get("/referral/list");
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const generateReferralCode = async (data = { type: "default" }) => {
  try {
    const response = await axiosInstance.post("/Referral/generate", data);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const trackReferral = async (code, eventType) => {
  try {
    const response = await axiosInstance.post(`/referral/track/${code}`, {
      eventType,
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getEarnings = async () => {
  try {
    const response = await axiosInstance.get("/referral/earnings");
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getSales = async () => {
  try {
    const response = await axiosInstance.get("/referral/sales");
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getRegistrations = async () => {
  try {
    const response = await axiosInstance.get("/referral/registrations");
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getEarningsByDateRange = async (startDate, endDate) => {
  try {
    const response = await axiosInstance.get(
      `/referral/earnings-by-date-range?startDate=${startDate}&endDate=${endDate}`
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const deactivateCode = async (code) => {
  try {
    const response = await axiosInstance.patch(`/referral/deactivate/${code}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getReferralEvents = async (page = 1, limit = 10) => {
  try {
    const response = await axiosInstance.get(
      `/referral/events?page=${page}&limit=${limit}`
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const generateFile = async () => {
  try {
    const response = await axiosInstance.get("/payment/generate-file", {
      responseType: "text",
    });

    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
